import type { HTMLAttributes } from 'react';
import './ui.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
}

export function Card({ title, subtitle, children, className = '', ...rest }: CardProps) {
  return (
    <div className={`ui-card ${className}`} {...rest}>
      {title ? (
        <div className="ui-card-header">
          <h2 className="ui-card-title">{title}</h2>
          {subtitle ? <p className="ui-card-subtitle">{subtitle}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
